$(function($) {
    $(document).ready(function() {

        //HEADER SLICKNAV MENU JS
        $('.main-menu').slicknav({
            prependTo:'.sub-header-area .menu-area',
            closeOnClick: true,
            label: 'Menu',
            duration: 1000,
        });

        /* HEADER MENU AREA START */
        $('#header-sub-menu').slicknav({
            prependTo:'.navigation-area .menu-area',
            closeOnClick: true,
            label: '',
            duration: 1000,
        });

        

        /* SLIDER AREA START */
        $('#related').owlCarousel({
            loop:false,
            dots:true,
            margin:15,
            nav:false,
            //navText : ["<img src='https://gtunify.nyc3.cdn.digitaloceanspaces.com/assets/img/left-arrow.svg'>","<img src='https://gtunify.nyc3.cdn.digitaloceanspaces.com/assets/img/right-arrow.svg'>"],
            autoplay:false,
            singleItem: true,
            responsive:{
                0:{
                    items:2
                },
                767:{
                    items:2
                },
                980:{
                    items:4
                }
            }
        });

        $('.exploring-slider ').owlCarousel({
            loop:true,
            margin:10,
            responsiveClass:true,
            responsive:{
                0:{
                    items:2,
                    nav:true
                },
                600:{
                    items:2,
                    nav:false
                },
                830:{
                    items:3,
                    nav:false
                },
                980:{
                    items:4,
                    nav:true,
                    loop:false
                }
            }
        });

      $('.slider-item-list.owl-carousel').owlCarousel({
            loop:true,
            dots:true,
            margin:15,
            nav:false,
            navText : ["<img src='https://gtunify.nyc3.cdn.digitaloceanspaces.com/assets/img/left-arrow.svg'>","<img src='https://gtunify.nyc3.cdn.digitaloceanspaces.com/assets/img/right-arrow.svg'>"],
            autoplay:false,
            autoplayHoverPause:true,
            autoplayTimeout:4000,
            autoplaySpeed: 1500,
            singleItem: true,
            responsive:{
                0:{
                    items:2
                },
                767:{
                    items:2
                },
                980:{
                    items:3
                }
            }
        });

      $('.js-load-more').on('click', function(e){
          e.preventDefault();
        
          var $btn = $(this);
          var baseUrl = $btn.data('base-url');
          var currentPage = parseInt($btn.data('current-page'), 10);
          var totalPages = parseInt($btn.data('total-pages'), 10);
        
          if (currentPage >= totalPages) {
            $btn.hide();
            return;
          }
        
          currentPage += 1;
          $btn.data('current-page', currentPage);
        
          var nextUrl = baseUrl + '?page=' + currentPage;
        
          $btn.text('Loading...').prop('disabled', true);
        
          $.ajax({
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML){
              var newItems = $(responseHTML).find('.single-product-item-list').html();
              $('.single-product-item-list').append(newItems);
        
              if (currentPage >= totalPages) {
                $btn.hide();
              } else {
                $btn.text('Load More').prop('disabled', false);
                $btn.attr('href', baseUrl + '?page=' + (currentPage + 1)); // optional for fallback
              }
            },
            error: function(){
              $btn.text('Load More').prop('disabled', false);
              alert('There was an error loading more products. Please try again.');
            }
          });
        });

        /* TABS AREA START */
        $('#tab1').click(function(){

            $('.tab-btn').removeClass('active-btn');
            $(this).addClass('active-btn');

            $('.tab-content').removeClass('active-content');
            $("#tab-content1").addClass('active-content');

        });

        $('#tab2').click(function(){

            $('.tab-btn').removeClass('active-btn');
            $(this).addClass('active-btn');

            $('.tab-content').removeClass('active-content');
            $("#tab-content2").addClass('active-content');

        });


        /* VIDEO ITEM */
        $(".video-area").fitVids();


    });

});


 var slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("dot");
  if(slides.length > 0 && dots.length > 0){
    if (n > slides.length) {slideIndex = 1}    
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";  
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";  
    dots[slideIndex-1].className += " active";
  }
  
}